<template>
  <el-card shadow="nerver">
    <!-- 添加poi -->
    <div style="display:flex">
      <div>
        <el-button @click="$router.push({ name: 'add_poi' })"
                   size="mini"
                   type="primary"
                   icon="el-icon-plus"
                   plain>添加POI</el-button>

      </div>
      <div style="margin-left:10px">
        <select-dest placeholder="所属目的地"
                     :destShowBack='destShowBack'
                     @selectDest="selectDest"></select-dest>
      </div>
    </div>
    <!-- 地图 -->
    <div>

    </div>
    <!-- 列表 -->
    <div>
      <el-table :data="poi_list"
                style="width: 100%">
        <el-table-column prop="poi_name"
                         label="poi名称"
                         width="180">
        </el-table-column>
        <el-table-column prop="dest"
                         label="目的地"
                         width="180">
        </el-table-column>
        <el-table-column label="经纬度">
          <template slot-scope="latlng">
            <div v-if="latlng.row.lat">
              <div>lat:{{latlng.row.lat}}</div>
              <div>lng:{{latlng.row.lng}}</div>
            </div>
            <div v-else>
              未绑定 <el-link @click="addLatLngToPoi(latlng.row)"
                       :underline="false">添加</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="添加坐标"
                 :visible.sync="dialogVisible"
                 width="60%"
                 :before-close="handleClose">
        <point-on-map @getLatLng="getLatLng"
                      @selectSuggestion="selectSuggestion"
                      ref="pointOnMap"></point-on-map>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import SelectDest from '../../components/common/select/SelectDest'
import PointOnMap from '../../components/map/PointOnMap'

export default {
  name: 'poi_hub_list',
  components: {
    SelectDest,
    'point-on-map': PointOnMap,
  },
  data() {
    return {
      dialogVisible: false,
      poi_list: [],
      destShowBack: 15,
      dest: 15,
      addLatLngPoiId: null,
    }
  },
  mounted() {
    this.getPoiHubList(this.dest)
  },
  methods: {
    // 点击选择目的地
    selectDest(value) {
      // console.log(value)
      this.dest = value
      this.getPoiHubList(this.dest)
    },
    // 给指定poi 添加坐标
    addLatLngToPoi(val) {
      // console.log(val)
      this.dialogVisible = true
      this.addLatLngPoiId = val.poi_id
    },
    // 添加定位的对话框关闭时
    handleClose() {
      this.dialogVisible = false
    },
    //
    getLatLng(lat, lng, map_source) {
      // console.log(lat, lng, map_source)
      let postItem = {
        poi_id: this.addLatLngPoiId,
        lat: lat,
        lng: lng,
        map_source: map_source,
      }
      this.$http.post('traver/save_latlng_band_poi', postItem).then((res) => {
        // console.log(res)
        if (res.data.errno == '0') {
          this.$message({
            message: res.data.errmsg,
            type: 'success',
          })
          this.addLatLngPoiId = null
          this.dialogVisible = false
          this.getPoiHubList(this.dest)
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // 检索器选 地点
    selectSuggestion() {},
    getPoiHubList(dest_id) {
      this.$http
        .get(`/get_poi_hub_list?source_map=2&dest_id=${dest_id}`)
        .then((res) => {
          // console.log(res)
          this.poi_list = res.data.poi_list
        })
    },
  },
}
</script>

<style>
</style>